"use client";

import type { AboutData } from "@/services/public.service";
import Image from "next/image";

export default function AboutStory({ about, isAr }: { about: AboutData; isAr: boolean }) {
  const title = isAr ? about.storyTitle.ar : about.storyTitle.en;
  const content = isAr ? about.storyContent.ar : about.storyContent.en;
  const img = about.storyImage || "/defaults/property.jpg";
  if (!title && !content) return null;

  return (
    <section className="container mx-auto px-6 py-16 md:py-20">
      <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="relative aspect-[4/3] rounded-3xl overflow-hidden shadow-xl bg-clay-100 order-last md:order-first">
          <Image src={img} alt={title} fill unoptimized className="object-cover" />
        </div>
        <div>
          <span className="inline-block w-12 h-1 rounded-full bg-clay-600 mb-6" />
          <h2 className="font-display text-3xl md:text-4xl font-bold text-clay-600 mb-5">{title}</h2>
          <div
            className="prose prose-lg max-w-none text-ink-500 leading-loose [&_strong]:text-ink-900"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    </section>
  );
}
